<template>
  <div
    class="form-group"
    :class="[
    inputGroupClass,
    {
      'has-prefix': !!$slots.prefix,
      'has-suffix': !!$slots.suffix
      }
    ]"
  >
    <label
      class="form-label"
      for="textarea-input"
      :class="{ 'has-error ': error }"
      v-if='label'
    >
      {{ label  }}
    </label>
    <div class="form-group__panel">
      <span class="form-control__prefix" for="textarea-input">
        <slot name="prefix"></slot>
      </span>
      <textarea
        id="textarea-input"
        class="form-control"
        :class="[inputClasses, { 'has-error ': error }]"
        :style="inputStyles"
        v-on="inputListeners"
        v-bind="$attrs"
      />
      <span class="form-control__suffix">
        <slot name="suffix"></slot>
      </span>
    </div>
    <transition name="slide">
      <span v-show="error" class="form-feedback is-danger">{{ error }}</span>
    </transition>
  </div>
</template>

<script>
/* eslint-disable arrow-parens */
import themeSetupMixin from '@/mixins/theme';
import inputMixin from '../input.mixin';

export default {
  mixins: [themeSetupMixin, inputMixin],
  props: {
    error: String,
    label: String,
    /**
     * ClassNames for input group
    */
    inputGroupClass: {
      type: String,
      default: '',
    },
    /**
     * ClassNames for input
    */
    inputClasses: {
      type: String,
      default: '',
    },
    /**
     * Inline Styles for input
    */
    inputStyles: {
      type: String,
      default: '',
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../../../assets/scss/_variables.scss";

textarea.form-control {
  font-family: $primaryFont;
}
.form-control__prefix{
  position: absolute;
  top:12px;
}
.form-control__suffix{
  position: absolute;
  top:12px;
}
</style>
